class Auth {
    isLoggedIn() {
        return !!localStorage.getItem('authToken');
    }
    getAdmin() {
        try {
            return JSON.parse(localStorage.getItem('admin')) || {};
        } catch (e) {
            return {};
        }
    }
    isAdmin() {
        return this.getAdmin().role === 'admin';
    }
    /* Super admin always passes; sub-admins are checked against their permissions object. */
    hasPermission(moduleKey, action = 'read') {
        const admin = this.getAdmin();
        if (admin.role === 'admin') return true;
        const perms = admin.permissions || {};
        return !!(perms[moduleKey] && perms[moduleKey][action] === true);
    }
}
export default new Auth();
